import Swal from 'sweetalert2';

const handleOpenSweetAlert = (message, type, options = {}) => {
  let confirmButtonColor = '#0655A5'; // Color corporativo primario
  let title = '';
  let icon = '';

  const {
    useHtml = false,          // si true, usa `html` en vez de `text`
    width = 'clamp(280px, 85vw, 420px)', // ancho responsivo con clamp
    showCancelButton = false, // mostrar botón cancelar
    confirmButtonText = 'Aceptar', // texto del botón confirmar
    cancelButtonText = 'Cancelar', // texto del botón cancelar
    focusCancel = false,           // enfocar botón cancelar
    ...restOptions                 // pasar opciones extra a Swal (input, etc)
  } = options;

  // Personaliza el título e icono según el tipo de alerta
  switch (type) {
    case 'success':
      title = 'Éxito';
      icon = 'success';
      confirmButtonColor = '#16a34a'; // Verde esmeralda moderno
      break;
    case 'error':
      title = 'Error';
      icon = 'error';
      confirmButtonColor = '#dc2626'; // Rojo moderno
      break;
    case 'warning':
      title = 'Advertencia';
      icon = 'warning';
      confirmButtonColor = '#ea580c'; // Naranja vibrante moderno
      break;
    case 'info':
    default:
      title = 'Información';
      icon = 'info';
      confirmButtonColor = '#0284c7'; // Azul moderno
      break;
  }

  // ✅ Fix aria-hidden: SweetAlert2 aplica aria-hidden="true" en #root de forma
  // SÍNCRONA al inicio de .fire(), ANTES de que willOpen se ejecute.
  // Por eso el blur debe hacerse AQUÍ, antes de llamar a Swal.fire().
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }

  // devolvemos la promesa de Swal.fire para poder hacer `await`
  return Swal.fire({
    icon,
    title,
    ...(useHtml ? { html: message } : { text: message }),
    showConfirmButton: true,
    confirmButtonText,
    confirmButtonColor,
    showCancelButton,
    cancelButtonText,
    cancelButtonColor: '#64748b',
    background: '#ffffff',
    backdrop: 'rgba(15, 23, 42, 0.45)',
    width,
    padding: 'clamp(1rem, 2vw, 1.75rem)',
    heightAuto: false,
    scrollbarPadding: false, // Evita que SweetAlert modifique el padding del body al abrir/cerrar
    allowOutsideClick: false,
    allowEscapeKey: true,
    returnFocus: false, // Evita el salto de foco forzado al cerrar
    reverseButtons: showCancelButton, // Cancelar a la izquierda
    focusCancel,
    customClass: {
      popup: 'swal2-premium-popup',
      title: 'swal2-premium-title',
      htmlContainer: 'swal2-premium-html',
      confirmButton: 'swal2-premium-confirm',
      cancelButton: 'swal2-premium-cancel',
      actions: 'swal2-premium-actions',
      icon: 'swal2-premium-icon',
    },
    // ✅ Fix: Asegurar que aparezca sobre modales de MUI (z-index > 1300)
    didOpen: () => {
      const container = Swal.getContainer();
      if (container) {
        container.style.zIndex = '9999';
      }
    },
    ...restOptions,
  });
};

export default handleOpenSweetAlert;